const methodMap = {

    // /** 管理登陆接口 **/
    // AdminLogin: { url: '/auth/r/login', method: 'post', apidata: 1 },
    // /** 验证黑名单 **/
    // blackCheckGet: { url: '/auth/user/vcode', method: 'get', apidata: 1 },
    // /**修改密码接口 **/
    // userPwdPut: { url: '/auth/user/pwd', method: 'put', },
    // /**获取菜单 权限功能点 **/
    // authMenuGet: { url: '/auth/menu', method: 'get' }, 
    // /*验证码图片*/
    // authVcodeGet: { url: '/auth/vcode', method: 'get', apidata: 1 },
    // /*token解析数据*/
    // authTokenInfoGet: { url: '/auth/token/info', method: 'get', apidata: 1 },
    /**获取省市区数据 **/  
    /* getcodedata: { url: '/mapshop/getcodedata/', method: 'get', },
    getprovince: { url: '/mapshop/getprovince/', method: 'get', },
    getcity: { url: '/mapshop/getcity/', method: 'get', },
    getdistrict: { url: '/mapshop/getdistrict/', method: 'get', }, */

    /**门店详细 **/
    /* Shopdetail: { url: 'shopdetail', method: 'get', },
    //省市区查询
    district:{ url: '/district', method: 'get', apidata: 1 }, */
    getSaMedalGrantInfo: { url: "parthelper/other/querySaMedalGrantInfo", method: 'post' },

};
export default methodMap;


// WEBPACK FOOTER //
// ./src/libs/apiMap.js